import { Injectable } from '@angular/core';
import { HubConnectionBuilder, HubConnection } from '@aspnet/signalr';
import { HttpService } from './http.service';
import { environment } from 'src/environments/environment';
import { Subject } from 'rxjs';
import { JwtService, tJWT } from './jwt.service';
import { AuthService } from './auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class SignalrService {
  private connection: HubConnection;
  private connectionStarted: Promise<void>;

  private jwt: tJWT;

  private subscriptions: { [key: string]: Subject<any> } = {};

  constructor(private http: HttpService, private jwtService: JwtService) {}

  public async logout() {
    await this.connection.stop();
    this.connectionStarted = undefined;
  }

  public get promise() {
    if (this.connectionStarted) return this.connectionStarted;
    return this.createConnection().then(() => this.connectionStarted);
  }

  public async createConnection() {
    const connectionBuilder = new HubConnectionBuilder();
    connectionBuilder.withUrl(
      `https://spokesperson${environment.production ? '' : '-staging'}.service.signalr.net/client/?hub=spokesperson`,
      {
        accessTokenFactory: () => this.getAccessToken()
      }
    );

    this.connection = connectionBuilder.build();

    this.connectionStarted = this.connection.start().catch(console.error);

    await this.connectionStarted;
    this.createListener();
  }

  private createListener() {
    this.connection.on('newMessage', msg => {
      if ('type' in msg && 'content' in msg) {
        if (!this.subscriptions[msg.type]) this.subscriptions[msg.type] = new Subject();
        this.subscriptions[msg.type].next(msg.content);
      }
    });
    this.connection.onclose(() => console.log('disconnected'));
  }

  public addEventListener<T = any>(type: string): Subject<T> {
    if (!this.subscriptions[type]) this.subscriptions[type] = new Subject();
    return this.subscriptions[type];
  }

  async getAccessToken() {
    if (!this.jwt || !this.jwt.valid() || this.jwt.expired()) {
      const res = await this.http
        .post<{ accessToken: string }>('minijobs', 'signalr', undefined, true)
        .catch(e => this.http.alertError(e));
      if (!res) return '';

      const num = await this.jwtService.addJWT(res.accessToken).catch(e => console.error(e));
      if (!num && num !== 0) return '';

      this.jwt = this.jwtService.getJWT(num);
    }

    return this.jwt.jwt;
  }
}
